import { controls, grouped } from "../controls";
const mark_leave_requests = {
    label: "Mark Leave Requests",
    pageLabel: "Mark Leave Requests", starting: true, url: "autogen",
    formActions: {},
    pageType: "history",
    filter: [
        ...controls.displayText({ tab: "general", label: "Employee", star: false }),
        ...controls.oc({
            tab: "general", c: "Employee", placeHolder: "Employee Code", name: "employee_code", fastpath: "employees", hidden: false
        }),
        ...controls.showData({
            tab: "general", displaytype: "capital", data: "employee_display"
        }),

        // ...controls.displayText({ tab: "filter", label: "Branch" }),
        // ...controls.oc({ tab: "filter", length: 4, c: "Branch", placeHolder: "Branch Code", name: "MarkLeaveRequest-branch-branch_code", fastpath: "branches" }),
        // ...controls.showData({ tab: "filter", displaytype: "capital", data: "MarkLeaveRequest-branch-branch_display" }),
        ...controls.displayText({ tab: "filter", label: "Leave Type" }),
        ...controls.oc({ tab: "filter", c: "LeaveType", placeHolder: "Leave Type Code", name: "MarkLeaveRequest-leave_type-leave_type_code", fastpath: "leave_types" }),
        ...controls.showData({ tab: "filter", displaytype: "capital", data: "MarkLeaveRequest-leave_type-leave_type_display" }),
    ]
    , form: [
        {
            widths: "col-sm-8",
            tab: "general",
            direction: 'vertical',
            style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
            pagination: { perPage: 30, buttonSize: 'col-sm-2' },
            subComponents: [
                // ...controls.displayText({ tab: "general", label: "Branch", star: false }),
                // ...controls.oc({ tab: "general", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches", hidden: false }),
                // ...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display", width: "col-sm-8" }),
                ...controls.displayText({ tab: "general", label: "Employee", star: false }),
                ...controls.oc({
                    tab: "general", c: "Employee", placeHolder: "Employee Code", name: "employee_code", fastpath: "employees", hidden: false,
                    displayData: {
                        privilege: "privilege", casual: "casual", medical: "medical", maternity: "maternity",
                        marriage_leave: "marriage_leave", paternity_leave: "paternity_leave", without_pay: "without_pay"
                    }
                }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "employee_display", width: "col-sm-8" }),
                ...controls.displayText({ tab: "general", label: "Leave Type", star: false }),
                ...controls.oc({ tab: "general", c: "LeaveType", placeHolder: "Leave Type Code", name: "leave_type_code", fastpath: "leave_types", hidden: false }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "leave_type_display", width: "col-sm-8" }),
                ...controls.magicDateLabel({ tab: "general", label: "From Date", target: "from_date", star: false }),
                ...controls.magicDate({ tab: "general", name: "from_date", dateType: "ontype" }),
                ...controls.displayText({ tab: "general", label: "" }),
                ...controls.magicDateLabel({ tab: "general", label: "To Date", target: "to_date", star: false }),
                ...controls.magicDate({ tab: "general", name: "to_date", dateType: "ontype" }),
                ...controls.displayText({ tab: "general", label: "" }),
            ],
        },

        grouped.leaveInformation('general')]
    , history: {
        perPage: 10,
        reportHeader: "Mark Leave Requests",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        clickable: true,
        displayColumns: [
            { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
            // { Header: "Branch", accessor: "MarkLeaveRequest-branch-branch_display", },
            { Header: "Name as on ID", accessor: "MarkLeaveRequest-employee-employee_display", },
            { Header: "Leave Type", accessor: "MarkLeaveRequest-leave_type-leave_type_display", },
            { Header: "From Date", accessor: "from_date", type: 'date' },
            { Header: "To Date", accessor: "to_date", type: 'date' },
        ]
    }
};
export default mark_leave_requests;


